import startCase from 'lodash/startCase';

export const formatResponse = response => {
  const formattedData = response.data.interviews.map(item => ({
    ...item,
    interviewType: item?.interviewType?.title ?? null,
    interviewDate: item?.interview_time_zone
      ? {
          date: item.interview_date ?? null,
          timezone: item.interview_time_zone,
          range: item.interview_range ?? null
        }
      : null,
    otherInterviewer: item.full_name ? startCase(item.full_name) : null
  }));
  return { ...response, data: { ...response.data, data: formattedData } };
};
